<template>
  <vs-table :data="data">
    <template slot="header">
      <vs-button color="success" type="filled" icon-pack="feather" icon="icon-file-plus" class="mx-2"
        @click="addItem">{{ $t('new') | capitalize }}
      </vs-button>

      <div class="con-input-search vs-table--search">
        <input class="input-search vs-table--search-input" type="text" v-model="text" @keypress.enter="search" />
        <vs-icon icon="search"></vs-icon>
        
      </div>
      <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-filter" class="mx-2" radius
          @click="openFilter"></vs-button>
    </template>
    <template slot="thead">
      <vs-th>
        {{ $t('client') | capitalize }}
      </vs-th>
      <vs-th>
        {{ $t('vendor') | capitalize }}
      </vs-th>
      <vs-th>
        {{ $t('departament') | capitalize }}
      </vs-th>
      <vs-th>
        {{ $t('category') | capitalize }}
      </vs-th>
      <vs-th>
        {{ $t('folio') | capitalize }}
      </vs-th>
      <vs-th>
        {{ $t('total') | capitalize }}
      </vs-th>
      <vs-th>
        {{ $t('currency') | capitalize }}
      </vs-th>
      <vs-th style="min-width: 100px;" class="text-center">
        
      </vs-th>
    </template>

    <template slot-scope="{ data }">
      <vs-tr :key="indextr" v-for="(tr, indextr) in data">
        <vs-td :data="data[indextr].client_name">
          {{ data[indextr].client_name }}
        </vs-td>
        <vs-td :data="data[indextr].vendor_name">
          {{ data[indextr].vendor_name }}
        </vs-td>
        <vs-td :data="data[indextr].departament_name">
          {{ data[indextr].departament_name }}
        </vs-td>
        <vs-td :data="data[indextr].category_name">
          {{ data[indextr].category_name }}
        </vs-td>
        <vs-td :data="data[indextr].name">
          {{ data[indextr].folio }}
        </vs-td>
        <vs-td :data="data[indextr].name" class="text-right">
          ${{ formatNumber(data[indextr].total, 2) }}
        </vs-td>
        <vs-td :data="data[indextr].name">
          {{ data[indextr].currency }}
        </vs-td>


        <vs-td :data="data[indextr]" >
          <div>
            <po-file
              :request_id="data[indextr].file_name"
              :title="$t('purchase_orders')"
            />
            <action-icon
              icon="CheckSquareIcon"
              :tooltip="$t('approve')"
              @click="confirmApprove(data[indextr])"
            />
          </div>
        </vs-td>
      </vs-tr>
      <vs-tr>
        <vs-td colspan="100%">
          <div v-if="data.length" v-observe-visibility="infiniteHandler"></div>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
</template>

<script>
import ActionIcon from '@/views/qb-components/actions/ActionIcon'
import ThSort from '@/views/components/ThSort'
import mixins from '@/mixins'
import PoFile from './PoFile.vue';

export default {
  components: {
    ActionIcon,
    ThSort,
    PoFile
  },
  data() {
    return {
      text: '',
      selected: {},
    }
  },
  methods: {
    addItem() {
      this.$emit('add')
    },
    infiniteHandler(isVisible) {
      if (!isVisible) {
        return
      }
      this.$emit('loadMore')
    },
    openFilter() {
      this.$emit('openFilter')
    },
    search() {
      this.$emit('search', this.text)
    },
    openFile(item) {
      this.$emit('openFile', item)
    },
    confirmApprove(item) {
      this.selected = {...item}
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$i18n.messages[this.$i18n.locale].approve,
        text: this.$i18n.messages[this.$i18n.locale].confirm_message,
        acceptText: this.$i18n.messages[this.$i18n.locale].yes,
        cancelText: this.$i18n.messages[this.$i18n.locale].cancel,
        accept: this.handleApprove,
      })
    },
    handleApprove() {
      this.$emit('approve', this.selected)
    },
  },
  mixins: [mixins],
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style>

</style>